import { render, staticRenderFns } from "./MoblieSupply.vue?vue&type=template&id=366a8c6d&scoped=true&"
import script from "./MoblieSupply.vue?vue&type=script&lang=js&"
export * from "./MoblieSupply.vue?vue&type=script&lang=js&"
import style0 from "./MoblieSupply.vue?vue&type=style&index=0&id=366a8c6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a8c6d",
  null
  
)

export default component.exports